import { useEffect } from 'react';

const pattern = ['c', 's', 'v'];

export default function GetCSV(countrySlug) {
  useEffect(() => {
    let complete = 0;

    const keyHandler = (event) => {
      if (pattern.indexOf(event.key) < 0 || event.key !== pattern[complete]) {
        complete = 0;
        return;
      }

      complete++;

      if (pattern.length === complete) {
        complete = 0;
        window.open(`https://graphics.thomsonreuters.com/data/2020/coronavirus/global-tracker/countries/${countrySlug}/csv/latest.csv`);
      }
    };

    document.addEventListener('keydown', keyHandler);
    return () => document.removeEventListener('keydown', keyHandler);
  }, [countrySlug]);
}
